export default __webpack_public_path__ + "static/media/Jack_of_spades.69765a4a.svg";